import { useEffect } from 'react'
import { createConsumer } from '@rails/actioncable'

interface Lesson {
  id: number
  lesson_date: string
  start_time: string
  end_time: string
  description: string
  status: string
  checked_in: boolean
  checked_in_at: string | null
  attendance_status: string
  teacher: {
    id: number
    name: string
  }
  student: {
    id: number
    name: string
  } | null
  is_available?: boolean
}

interface UseLessonsChannelProps {
  schoolId: number | undefined
  onLessonCreated?: (lesson: Lesson) => void
  onLessonUpdated?: (lesson: Lesson) => void
  onLessonDeleted?: (lessonId: number) => void
}

export function useLessonsChannel({
  schoolId,
  onLessonCreated,
  onLessonUpdated,
  onLessonDeleted,
}: UseLessonsChannelProps) {
  useEffect(() => {
    if (!schoolId) return

    // Cria consumer do ActionCable
    const cable = createConsumer()

    // Subscribe ao canal de lessons
    const subscription = cable.subscriptions.create(
      {
        channel: 'LessonsChannel',
        school_id: schoolId,
      },
      {
        received(data: any) {
          switch (data.type) {
            case 'lesson_created':
              onLessonCreated?.(data.lesson)
              break
            case 'lesson_updated':
              onLessonUpdated?.(data.lesson)
              break
            case 'lesson_deleted':
              onLessonDeleted?.(data.lesson_id)
              break
          }
        },
      },
    )

    // Cleanup quando desmontar
    return () => {
      subscription.unsubscribe()
      cable.disconnect()
    }
  }, [schoolId, onLessonCreated, onLessonUpdated, onLessonDeleted])
}
